export default __webpack_public_path__ + "static/media/not_found_lg.5e2497ba.jpg";